export enum StorageKeyEnum {
  sessionToken,
  userEmail,
  userInfo,
  imageLogo,
  userCountry,
  multiregion,
  multiregionLoaded,
  clientToken,
  fireBaseConfigured,
  userRol,
  limitCurrentAccount,
  firstCallDashboardRealized,
  userId,
  userType,
  fullName,
  surrenderStorageGrid,
  surrenderDriver,
  carrierCode,
  sometimeEntered,
  firebaseToken,
  permissions,
  passengerId,
  fantasyName,
  placeLNG,
  placeLAT,
  place,
  placeName,
  agreedTerms,
  subUserId,
  subUserPassengerId,
  pageSize,
  defaultLanguage,
  countryCode,
  timezone,
  mercadoPagoAppId,
  mercadoPagoAppCode,
  mercadoPagoAvailable,
  mailchimpAppId,
  mailchimpAvailable,
  driverMapZoom,
  driverMapBounds,
  surrenderVehicle,
  subUserName,
  affiliateProfileId,
  affiliateProfileActive,
  affiliateProfileCreditCardWarrantyExpired,
  paymentVendorAvailableInCarrierCountry,
  disableFunctions,
  isOwnerPlatformUser,
  userInfoCarrier,
  flightApiAvailable,
  flightApiName,
  gnetApiAvailable,
  maxRouteWaypoints,
  isNotificacionEnable,
  formClientMode,
  isMmau
}
